import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a533db08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full border-t border-white bg-black"
}
const _hoisted_2 = { class: "o-page-wrapper-gutter min-h-45 w-full text-white flex items-center justify-between" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isCustomerService)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "pr-30",
            innerHTML: _ctx.infoTextHTML
          }, null, 8, _hoisted_3),
          _createElementVNode("button", {
            class: "c-magic-line hover:text-white whitespace-nowrap",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)), ["prevent"]))
          }, " Sign out ")
        ])
      ]))
    : _createCommentVNode("", true)
}